import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'// Progress 进度条样式

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

export const constantRouterMap = [
  { path: `${__publicPath}/`, component: () => import('./components/List')},
  { path: `${__publicPath}/ListforApp`, component: () => import('./components/ListforApp')},
  { path: `${__publicPath}/settings`, component: () => import('./components/Settings')},
  { path: '*', component: () => import('./components/404')}
]

const router = new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: constantRouterMap
})

// NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  // NProgress.start();
  next();
});

router.afterEach(() => {
  // NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./router.js